import React from 'react';

import {AppContext} from '../../../AppModule/Context';

import AnimatedSvgLogo from '../../common/genericComponents/animatedSvgLogo';
import ButtonComponent from '../../common/genericComponents/redesign/buttonComponent/buttonComponent';
import CommunicationIcons from '../../../assets/svgComponents/communicationIcons';

import VIDABOO_CONSTANTS from '../../../config/consts';

import './customLinkComponent.css';

class CustomLinkComponent extends React.Component {
  sendLinkClick = () => {
    this.props.sendGA(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_CUSTOM_LINK_MESSAGE,
    );
    this.props.dispatchConsoltoEvents(
      VIDABOO_CONSTANTS.ANALYTICS_ACTIONS.WIDGET.SEND_CUSTOM_LINK_MESSAGE,
    );
    const customLink = this.props.mentor.mentorDto.customLink;
    if (customLink) {
      window.open(customLink, '_blank');
    }
  };

  render() {
    return (
      <div
        className={
          this.props.isPersonalPage
            ? 'et-personal-page-right-content-wrap'
            : 'et-widget-body-content-wrap'
        }>
        <div
          className={`et-v2-custom-link-container ${this.props.isPersonalPage ? 'et-v2-pp-custom-link-container' : ''}`}>
          <div
            className="et-v2-custom-link-icon-text-wrap"
            onClick={() => {
              this.sendLinkClick();
              this.props.callSendMessageFunc(
                'Custom Link',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.CUSTOM_LINK_MESSAGE,
              );
            }}>
            {this.props.showNewUI ? (
              <div className="et-v2-custom-link-animated-svg-logo-wrap">
                <AnimatedSvgLogo
                  type={VIDABOO_CONSTANTS.ANIMATED_SVG_LOGO_TYPES.CUSTOM_LINK}
                />
              </div>
            ) : (
              <div className="et-v2-custom-link-icon-wrap">
                <CommunicationIcons.CustomLinkIcon fillColor="var(--et-mentor-cta-btn-primary-background-color-fc)" />
              </div>
            )}
            <div className="et-v2-custom-link-inner-txt">
              {this.props?.mentor?.mentorDto?.appControlDto
                ?.widgetEditableTexts[
                VIDABOO_CONSTANTS.WIDGET_APP_TYPES.CUSTOM_LINK
              ] || (
                <>
                  Visit our <br /> Custom Link
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className={`et-v2-widget-btn-wrap ${this.props.isPersonalPage ? 'et-v2-clickntalk-btn-wrap' : ''}`}>
          <ButtonComponent
            onClick={() => {
              this.sendLinkClick();
              this.props.callSendMessageFunc(
                'Custom Link',
                VIDABOO_CONSTANTS.CHAT_SUBTYPES.CUSTOM_LINK_MESSAGE,
              );
            }}
            image={
              this.props.isPersonalPage ? (
                <div className="et-v2-custom-link-btn-img">
                  <CommunicationIcons.CustomLinkIcon
                    size={25}
                    fillColor="#fff"
                  />
                </div>
              ) : null
            }
            text={
              (this.props.mentor.mentorDto.appControlDto.widgetEditableTexts &&
                this.props.mentor.mentorDto.appControlDto.widgetEditableTexts[
                  VIDABOO_CONSTANTS.WIDGET_APP_CTA_TYPES_BTN_TEXT.CUSTOM_LINK
                ]) ||
              'Visit Link'
            }
          />
        </div>
      </div>
    );
  }
}

CustomLinkComponent.contextType = AppContext;
export default CustomLinkComponent;
